export const WELCOME_OFFER_SRC_PATH = '/lp/welcome-offer';

export const LOCALE_OFFERS: Record<string, string> = {
  de: 'prize-de_v2',
  'en-AU': 'prize-au_v2',
  'en-NZ': 'prize-nz_v2',
  'en-CA': 'prize-ca_v2',
  'fr-CA': 'prize-fr-ca_v2',
  'fr-CH': 'prize-fr-ch_v2',
};
